export class Room {
    id:number | undefined
    name: String | undefined
}
